// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"dd44cf5c","453":"bc6b81a8","850":"041acdf1"}[chunkId] + ".chunk.js";
};